/**
 * Important Date Create Component
 * Form for creating new important dates for users
 */

import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  DateInput,
  NumberInput,
  BooleanInput,
  required,
} from 'react-admin';
import { Typography, Box } from '@mui/material';
import { DATE_TYPE_CHOICES } from '../constants';
import { UserSelectInput } from './shared/UserSelectInput';

export function ImportantDateCreate() {
  return (
    <Create title="Create Important Date">
      <SimpleForm>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
          <Typography variant="h6" gutterBottom>New Important Date</Typography>

          <UserSelectInput source="userId" label="User" validate={required()} />

          <TextInput
            source="name"
            label="Name"
            validate={required()}
            fullWidth
          />

          <Box sx={{ display: 'flex', gap: 2 }}>
            <DateInput
              source="date"
              label="Date"
              validate={required()}
            />

            <SelectInput
              source="type"
              label="Type"
              choices={DATE_TYPE_CHOICES}
              validate={required()}
              defaultValue="custom"
              sx={{ minWidth: 200 }}
            />
          </Box>

          <TextInput
            source="notes"
            label="Notes"
            multiline
            rows={2}
            fullWidth
          />

          <Box sx={{ display: 'flex', gap: 2 }}>
            <NumberInput
              source="reminderOffset"
              label="Reminder Offset (days)"
              helperText="Days before the date to send reminder"
              defaultValue={1}
            />

            <NumberInput
              source="partnerReminderOffset"
              label="Partner Reminder Offset (days)"
              helperText="Days before to remind partner"
            />
          </Box>

          <BooleanInput
            source="sharedWithPartner"
            label="Shared with Partner"
            defaultValue={false}
          />
        </Box>
      </SimpleForm>
    </Create>
  );
}
